module.exports = __webpack_public_path__ + "img/custom-9.5020ba55.svg";